/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import investorData from "layouts/applications/data-tables/data/investors";
import companyData from "layouts/applications/data-tables/data/companies";

function DataTables(props) {
  const {investors, companies} = props

  console.log(investorData, "investorData")
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <MDBox mb={3}>
          <Card>
            <MDBox p={3} lineHeight={1}>
              {investors ? 
              <>
              <MDTypography variant="h5" fontWeight="medium" marginBottom='15px'>
                Qualified Investors
              </MDTypography>
              <MDTypography variant="p" color="text" >
                List of qualified investors, including accelerators, venture capital firms, etc.
              </MDTypography>
              <MDBox marginTop='10px'>
                <MDTypography variant="button" color="text">
                  Using commercially available data from an independent information provider (IIP) to validate basic information about companies or organizations petitioning to employ non-citizens.
                </MDTypography>
              </MDBox>
              </>
              :
              <>
              <MDTypography variant="h5" fontWeight="medium" marginBottom='15px'>
                Qualified Companies
              </MDTypography>
              <MDTypography variant="p" color="text">
                List of qualified companies, including startups
              </MDTypography>
              <MDBox marginTop='10px'>
                <MDTypography variant="button" color="text">
                  Using commercially available data from an independent information provider (IIP) to validate basic information about companies or organizations petitioning to employ non-citizens.
                </MDTypography>
              </MDBox>
              </>
              }
              
            </MDBox>
            {investors ?
              <DataTable table={investorData} />
              :
              <DataTable table={companyData} />
            }
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DataTables;
